export default __webpack_public_path__ + "static/media/counselling.76ef6a87.jpg";